<template>
  <div>
    <Breadcrumb >
      <BreadcrumbItem>首页</BreadcrumbItem>
      <BreadcrumbItem>活动管理</BreadcrumbItem>
      <BreadcrumbItem :to="{name: 'meeting-list'}">活动列表</BreadcrumbItem>
      <BreadcrumbItem>活动信息</BreadcrumbItem>
    </Breadcrumb>
    <div class="single-page ivu-article">
      <Card>
        <p slot="title">
          <Icon type="ios-list-outline"></Icon>
          活动信息
        </p>
        <router-link :to="{name: 'meeting-list'}" slot="extra">
          <Icon type="ios-arrow-back"></Icon>
          返回列表
        </router-link>
        <Form ref="formValidate" class="meeting-form" :model="meeting" :rules="ruleValidate"  label-position="top">
          <FormItem label="活动标题" prop="title">
            <Input size="large" v-model="meeting.title"></Input>
          </FormItem>
          <FormItem label="活动类型" prop="kind">
            <Select v-model="meeting.kind">
              <Option value="meeting">境内会议</Option>
              <Option value="training">培训</Option>
              <Option value="exhibition">展览</Option>
              <Option value="team">出访团组</Option>
              <Option value="examination">考试</Option>
            </Select>
          </FormItem>
          <FormItem label="费用">
            <RadioGroup v-model="meeting.free">
              <Radio :label="1">免费</Radio>
              <Radio :label="0">付费</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="活动开始时间" prop="startDate">
            <DatePicker :value="formatDate(meeting.startDate, 'YYYY-MM-DD HH:mm')" @on-change="handleStartDateChange" size="large" type="datetime" show-week-numbers placeholder="选择日期和时间"
                        format="yyyy-MM-dd HH:mm" style="width: 100%" ></DatePicker>
          </FormItem>
          <FormItem label="活动结束时间" prop="endDate">
            <DatePicker :value="formatDate(meeting.endDate, 'YYYY-MM-DD HH:mm')" @on-change="handleEndDateChange" type="datetime" size="large" show-week-numbers placeholder="选择日期和时间"
                        format="yyyy-MM-dd HH:mm" style="width: 100%"></DatePicker>
          </FormItem>
          <FormItem>
            <Checkbox v-model="meeting.onLineMeeting">这是一个线上活动</Checkbox>
          </FormItem>

          <FormItem>
            <Checkbox v-model="meeting.noNeedRegistration">不需要报名（活动只用于展示，不需要用户报名）</Checkbox>
          </FormItem>

          <FormItem label="举办城市">
            <RadioGroup v-model="meeting.addressCountry" >
              <Radio label="中国" :disabled="meeting.onLineMeeting">中国</Radio>
              <Radio label="境外" :disabled="meeting.onLineMeeting">境外</Radio>
            </RadioGroup>
            <al-cascader v-if="meeting.addressCountry === '中国'" v-model="provinceAndCity" :disabled="meeting.onLineMeeting" size="large" data-type="name" level="1" />
          </FormItem>
          <FormItem label="活动详细地址" prop="addressDetail" >
            <Input v-model="meeting.addressDetail" size="large" :disabled="meeting.onLineMeeting"></Input>
          </FormItem>

          <FormItem label="主办方" prop="host" style="margin-top: 10px">
            <tinymce id="host" v-model.trim="meeting.host" :other_options="getTinyMceOptions(100)"></tinymce>
          </FormItem>
          <FormItem label="承办方" style="margin-top: 10px">
            <tinymce id="organizer" v-model.trim="meeting.organizer" :other_options="getTinyMceOptions(100)"></tinymce>
          </FormItem>
          <FormItem label="上传活动封面">
            <Row>
              <Col span="14">
              <div style="width: 260px; height: 163px; border: 1px solid #dddee1">
                <img width="260" height="163" :src="`/api/admin/meetings/cover/show?path=${meeting.coverImgPath}`"/>
              </div>
              </Col>
              <Col span="10">
              <Upload
                  :headers="{Authorization: `Bearer ${token}`}"
                  :action="`/api/admin/meetings/cover/upload`"
                  accept="image/*"
                  :format="['jpg','jpeg','png']"
                  :on-format-error=handleCoverImageFormatError
                  :max-size="1024"
                  :on-exceeded-size="handleMaxSizeOfCover"
                  :on-success="onUploadCoverSuccess">
                <Button type="info" icon="ios-cloud-upload-outline">上传封面（图片大小不超过1M）</Button>
              </Upload>
              <Button type="default"  @click="meeting.coverImgPath = null">
                <Icon type="ios-trash-outline" />
                删除封面</Button>
                <Alert style="margin-top: 10px" type="error">提示：请勿上传涉及版权的图片或字体。如侵权，后果由活动发布方承担。</Alert>
              <Alert >
                  建议图片尺寸：长宽比 5:3，推荐450*270
                </Alert>
              </Col>
            </Row>
          </FormItem>
          <FormItem label="活动简介" prop="briefIntroduction">
            <Alert>简介中如有图片请使用插入图片功能上传图片。<br>
              (如果发现拷贝的文本无法修改样式，请选择【编辑】【作为文本粘贴】功能后，再尝试粘贴文本。)</Alert>
            <tinymce id="briefIntroEditor" v-model="meeting.briefIntroduction" :other_options="getTinyMceOptions(300)"></tinymce>
          </FormItem>
          <FormItem label="活动日程" style="margin-top: 10px">
            <tinymce id="agenda" v-model.trim="meeting.agenda" :other_options="getTinyMceOptions(300)"></tinymce>
          </FormItem>
          <FormItem label="主办方联系方式">
            <!--<Alert>此处可添加官网网址、票务合作、咨询热线等信息。</Alert>-->
            <tinymce id="contactEditor" v-model="meeting.contact" :other_options="getTinyMceOptions(200)"></tinymce>
          </FormItem>
          <FormItem label="直播回看内容">
            <tinymce id="replayContentEditor" v-model="meeting.replayContent" :other_options="getTinyMceOptions(200)"></tinymce>
          </FormItem>
          <FormItem v-show="user.id === 1" label="第三方报名链接">
            <Input size="large" v-model="meeting.signLink"></Input>
          </FormItem>
          <FormItem v-show="user.id === 1" label="自定义第三方报名链接样式">
            <tinymce id="customSignLinkStyle" v-model="meeting.customSignLinkStyle" :other_options="getTinyMceOptions(200)"></tinymce>
          </FormItem>
          <FormItem label="活动附件">
            <div class="demo-upload-list" v-for="(item, idx) in attachments" :key="item.id">
              <div> {{ item.fileName }}</div>
              <div class="demo-upload-list-cover">
                <Icon type="ios-trash-outline" @click.native="handleRemove(idx)"></Icon>
              </div>
            </div>
            <Upload
                ref="upload"
                :headers="{Authorization: `Bearer ${token}`}"
                :show-upload-list="false"
                :on-success="onUploadAttachmentSuccess"
                :format="['jpg','jpeg','png', 'doc', 'docx', 'pdf', 'xls', 'xlsx', 'ppt', 'pptx' ]"
                :max-size="10240"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                multiple
                type="drag"
                action="/api/admin/meetings/attachments/upload"
                style="display: inline-block;width:58px;">
              <div style="width: 58px;height:58px;line-height: 70px;">
                <Icon type="ios-cloud-upload" size="32"></Icon>
              </div>
            </Upload>
          </FormItem>
          <FormItem label="目标网站">
            <CheckboxGroup v-model="meeting.targetWebsiteArr">
              <Checkbox label="lianmeng">陆海新通道国际工商会联盟</Checkbox>
<!--              <Checkbox label="chuhai">出海</Checkbox>-->
            </CheckboxGroup>
          </FormItem>
          <p>
            <FormItem>
              <Button type="primary" style="float: right" size="large" long :disabled="saving" @click="save">保存活动</Button>
              <!--<Button v-if="meeting.status === 0" type="error" size="large" @click="publish" style="margin-left: 8px">发布活动</Button>-->
            </FormItem>
          </p>
        </Form>
      </Card>
    </div>
  </div>
</template>
<script>

import Vue from 'vue'
import { mapState } from 'vuex'
import moment from 'moment'
import tinymce from './components/TinymceVue'

export default {
  name: 'MeetingCreate',
  props: ['id'],
  components: {tinymce},
  data () {
    return {
      meeting: {
        host: null,
        organizer: null,
        briefIntroduction: null,
        agenda: null,
        contact: null,
        addressCountry: '中国',
        free: 1,
        noNeedRegistration: false,
        onLineMeeting: false,
        targetWebsiteArr: []
      },
      attachments: [],
      saving: false,
      saved: false,
      tinymceOptions: {
        menubar: 'edit insert view format table tools',
        theme: 'modern',
        height: 300,
        relative_urls: false,
        convert_urls: false,
        images_upload_url: '/api/admin/cms/articles/img/upload',
        images_upload_base_path: '/api/admin/cms/articles/img/show?path=',
        paste_data_images: true,
        branding: false,
        table_default_styles: {
          width: '100%',
          borderCollapse: 'collapse'
        }
      },

      ruleValidate: {
        title: [
          {required: true, message: '请输入活动标题'}
        ],
        kind: [
          {required: true, message: '请选择活动类型'}
        ],
        startDate: [
          {required: true, message: '请选择开始时间'}
        ],
        endDate: [
          {required: true, message: '请选择结束时间'}
        ],
        addressDetail: [
          {required: false, message: '请输入详细地址'}
        ],
        briefIntroduction: [
          {required: true, message: '请输入活动简介'}
        ],
        host: [
          {required: true, message: '请输入活动主办方'}
        ]
      }
    }
  },
  computed: {
    ...mapState([
      'token',
      'user'
    ]),
    provinceAndCity: {
      get () {
        return [this.meeting.addressProvince, this.meeting.addressCity]
      },
      set (newValue) {
        this.meeting.addressProvince = newValue[0]
        this.meeting.addressCity = newValue[1]
      }
    }
  },
  methods: {
    handleStartDateChange (date) {
      // this.meeting.startDate = new Date(date)
      if (date) {
        Vue.set(this.meeting, 'startDate', new Date(date))
      } else {
        Vue.set(this.meeting, 'startDate', '')
      }
    },
    handleEndDateChange (date) {
      // this.meeting.endDate = new Date(date)
      if (date) {
        Vue.set(this.meeting, 'endDate', new Date(date))
      } else {
        Vue.set(this.meeting, 'endDate', '')
      }
    },
    initMeeting () {
      return this.meeting
    },
    formatDate (timestamp, pattern) {
      if (timestamp) {
        return moment(timestamp).format(pattern)
      } else {
        return null
      }
    },
    getTinyMceOptions (height) {
      let options = JSON.parse(JSON.stringify(this.tinymceOptions))
      if (height) {
        options.height = height
      } else {
        options.height = 300
      }
      return options
    },
    setMeeting (meeting) {
      if (meeting.onLineMeeting === null) {
        meeting.onLineMeeting = false
      }
      if (meeting.hideHost === null) {
        meeting.hideHost = false
      }
      if (meeting.targetWebsite) {
        meeting.targetWebsiteArr = meeting.targetWebsite.split(',')
      } else {
        meeting.targetWebsiteArr = []
      }
      this.meeting = meeting
      if (meeting.attachments) {
        this.attachments = meeting.attachments
      } else {
        this.attachments = []
      }
    },
    getMeeting () {
      this.meeting.attachments = this.attachments
      if (this.meeting.addressCountry !== '中国') {
        this.meeting.addressProvince = null
        this.meeting.addressCity = null
      }
      if (this.meeting.organizer === '') {
        this.meeting.organizer = null
      }
      this.meeting.targetWebsite = this.meeting.targetWebsiteArr.join(',')

      return this.meeting
    },
    beforeSave () {
      this.$Message.destroy()
      this.$Loading.start()
      this.saving = true
    },
    afterSave (e) {
      this.$Loading.finish()
      if (e) {
        this.$Message.error({
          content: e.body.error || '操作失败，请重试',
          duration: 0,
          closable: true
        })
      } else {
        this.$Message.success('操作成功！')
      }
      this.saving = false
      this.saved = false
    },
    onUploadCoverSuccess (response) {
      this.$set(this.meeting, 'coverImgPath', response.filePath)
    },
    onUploadAttachmentSuccess (response) {
      this.attachments = this.attachments.concat(response)
    },
    handleRemove (idx) {
      this.attachments.splice(idx, 1)
    },
    handleCoverImageFormatError (file) {
      this.$Message.error({
        content: '允许上传图片格式 jpg, jpeg, png',
        duration: 0,
        closable: true
      })
    },
    handleFormatError (file) {
      this.$Message.error({
        content: '允许上传文件格式 jpg, jpeg, png, doc, docx, pdf, xls, xlsx, ppt, pptx ',
        duration: 0,
        closable: true
      })
    },
    handleMaxSize (file) {
      this.$Message.error({
        content: '单个文件最大允许10M，全部文件最大允许50M',
        duration: 0,
        closable: true
      })
    },
    handleMaxSizeOfCover (file) {
      this.$Message.error({
        content: '图片大小不要超过1M',
        duration: 0,
        closable: true
      })
    },
    async save () {
      let validPass = false
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          validPass = true
        } else {
          validPass = false
        }
      })

      if (!validPass) {
        return
      }

      try {
        this.beforeSave()
        if (this.id) {
          // 更新活动
          this.meeting = (await this.$http.put(`/api/admin/meetings/${this.id}`, this.getMeeting())).body
          this.$router.push({name: 'meeting-list'})
        } else {
          // 创建活动
          this.meeting.status = 0 // 状态：未发布
          this.meeting.creatorAdminUserId = this.$store.state.user.id
          this.meeting = (await this.$http.post('/api/admin/meetings', this.meeting)).body
          this.$router.push({name: 'meeting-list'})
        }
        this.afterSave()
      } catch (e) {
        this.afterSave(e)
      }
    },

    handleReset (name) {
      this.$refs[name].resetFields()
    }
  },
  async beforeRouteEnter (to, from, next) {
    if (to.params.id) {
      try {
        let resp = await Vue.http.get(`/api/admin/meetings/${to.params.id}`)
        next(vm => {
          vm.setMeeting(resp.body)
          vm.saving = false
          vm.saved = false
        })
      } catch (e) {
        next(vm => {
          vm.setMeeting({})
          vm.saving = false
          vm.saved = false
        })
      }
    } else {
      next(vm => {
        vm.setMeeting(vm.initMeeting())
        vm.saving = false
        vm.saved = false
      })
    }
  },
  async beforeRouteUpdate (to, from, next) {
    if (to.params.id) {
      try {
        let resp = await Vue.http.get(`/api/admin/meetings/${to.params.id}`)
        this.setMeeting(resp.body)
        this.saving = false
        this.saved = false
        next()
      } catch (e) {
        this.setMeeting({})
        this.saving = false
        this.saved = false
        next()
      }
    } else {
      this.setMeeting(this.initMeeting())
      this.saving = false
      this.saved = false
      next()
    }
  }
}
</script>
<style lang="scss" scoped>
  .meeting-form {
    width: 900px;
    margin: 0 auto;
    padding-right: 180px;
  }
  .demo-upload-list{
    display: inline-block;
    /*width: 60px;*/
    height: 60px;
    padding: 0 3px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
  }
  .demo-upload-list img{
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .demo-upload-list:hover .demo-upload-list-cover{
    display: block;
  }
  .demo-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
  /deep/.ivu-form .ivu-form-item-label {
    font-size: 13px !important;
  }
  /deep/ .ivu-form-item-error .mce-tinymce {
    border: 1px solid #ed4014 !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/meeting/Detail.vue